import SiteHeaderV2 from "@/components/v2/SiteHeaderV2";
import GlossaryContent from "@/components/GlossaryContent";
import { BookMarked } from "lucide-react";

export default function GlossaryV2() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SiteHeaderV2 />
      <section className="max-w-4xl mx-auto px-6 pt-14 pb-4">
        <div className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-bold text-brand mb-3">
          <BookMarked className="w-4 h-4" /> Key terms
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter font-black text-slate-900">Trucking Glossary</h1>
        <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">
          Every acronym and term from your missions, in plain English. Search for anything you're unsure about — LLC,
          EIN, MC, BOC-3, MVR, IFTA and more.
        </p>
      </section>
      <section className="max-w-4xl mx-auto px-6 pb-24">
        <GlossaryContent />
      </section>
    </div>
  );
}
